export function projectedScrollSpeed(item, source, sourceViewport, target, targetViewport) {
  const distance = (asset, viewport) => {
    const mode = Number(asset.playbackMode);
    if (![2, 3].includes(mode)) throw new Error("Scroll timing requires scrolling artwork.");
    return mode === 2 ? Number(asset.width) - (item.loopArtwork ? 0 : viewport.width)
      : Number(asset.height) - (item.loopArtwork ? 0 : viewport.height);
  };
  const oldDistance = distance(source, sourceViewport), newDistance = distance(target, targetViewport);
  const oldSpeed = Number(item.speedPxPerSecond);
  if (!(oldDistance > 0 && newDistance > 0 && Number.isFinite(oldSpeed) && oldSpeed > 0))
    throw new Error("The scrolling artwork has invalid travel geometry.");
  const speed = oldSpeed * newDistance / oldDistance;
  if (!Number.isFinite(speed) || speed < (Number(target.playbackMode) === 3 ? 5 : 1) || speed > 60)
    throw new Error("This Pirdy cannot preserve the selected scroll timing. Adjust the scroll speed before exporting; no slower playback was substituted.");
  return speed;
}
